import { useContext } from "react";
import { AppContext } from "../../../../../../contexts/appContext";
import "./ViewCategoryComponent.scss";
import BreadcrumbComponent from "../../../../../../components/BreadcrumbComponent/BreadcrumbComponent";
import { CategoryTitle, SeparatorBlue600 } from "../../../../../../components/styled-components";
import DownloadPdfComponent from "../../../../../../components/DownloadPdfComponent/DownloadPdfComponent";
import CategoryDetailListLink from "../CategoryDetailListLink/CategoryDetailListLink";
import { BREADCRUMB_MAP } from "../../../../../../utils/BreadcrumbEnums";
import globals from "../../../../../../config/appconfig";
import waferssServices from "../../../../../../hooks/waferssServices";
import { useQuery } from "react-query";
import CategoryDetailAllegattiListComponent from "../CategoryDetailAllegattiListComponent/CategoryDetailAllegattiListComponent";
import CategoryDetailAppListComponent from "../CategoryDetailAppListComponent/CategoryDetailAppListComponent";
import CategoryDetailMoreInformationComponent from "../CategoryDetailMoreInformationComponent/CategoryDetailMoreInformationComponent";
import CategoryDetailViewImageComponent from "../CategoryDetailViewImageComponent/CategoryDetailViewImageComponent";
import CategoryDetailNotaMetodologicaComponent from "../CategoryDetailNotaMetodologicaComponent/CategoryDetailNotaMetodologicaComponent";
import CategoryDetailViewTextComponent from "../CategoryDetailViewTextComponent/CategoryDetailViewTextComponent";
import { Helmet } from "react-helmet";
import { APP_NAME } from "../../../../../../utils/Constans";

/**
 * @function ViewCategoryComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
 */
const ViewCategoryComponent = ({ info }) => {
    const { menu } = useContext(AppContext);
    const currentSection = menu?.find(m => m.tipologia === info?.tipologia);
    const { contenuto, id } = info;
    const { getCheckPdf, getPdfCategory } = waferssServices();

    const { data: checkPdf } = useQuery(["checkPdf", id], () => getCheckPdf('pub-' + id), {
        enabled: !!(id)
    });

    const { refetch } = useQuery("getPdfCategory", () => getPdfCategory('pub-' + id), {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: (pdf) => {
            const base64 = pdf?.data;
            const binary = atob(base64.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            const blob = new Blob( [view], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            const downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            const fileName = contenuto?.titoloContenuto?.titoloContenuto + ".pdf";
            downloadLink.href = url;
            downloadLink.download = fileName;
            downloadLink.click();
            document.body.removeChild(downloadLink);

            // window.open(url);
        }
    });

    const category = menu?.find(m => m?.voci?.some(a => a?.idContenuto === info?.id))?.voci?.find(v => v?.idContenuto === info?.id);

    return (
        <>
            <div className="ViewCategoryComponent">
                <BreadcrumbComponent items={[BREADCRUMB_MAP.HOME_PAGE, { name: currentSection?.etichetta, href: "", sezione: currentSection, categoria: "" }]}></BreadcrumbComponent>
                <Helmet>
                    <title>{APP_NAME} | {contenuto?.titoloContenuto?.titoloContenuto}</title>
                </Helmet>
                <CategoryTitle><div role="contentinfo" tabIndex="0" aria-label={contenuto?.titoloContenuto?.titoloContenuto}>{contenuto?.titoloContenuto?.titoloContenuto}</div></CategoryTitle>
                <div className="text-end my-4"><DownloadPdfComponent actionBtn={() => refetch()} classBtn={`${!(checkPdf?.data) ? "primary disabled" : "primary"}`} CategoryName={info.nome} isOutName={true}></DownloadPdfComponent></div>
                {contenuto?.immagineCarousel?.file ? (
                    <div className="mb-4 text-center" role="contentinfo" tabIndex="0">
                        <img
                            src={`${globals["app-url-bucket"]}${contenuto?.immagineCarousel?.file}`}
                            title={contenuto?.titoloContenuto?.titoloContenuto}
                            alt={contenuto?.immagineCarousel?.testoAlternativo}
                            className="ViewCategoryComponent__imgOne img-fluid"
                        />
                    </div>
                ) : null}

                {contenuto?.secondaImmagine?.file ? (
                    <div className="mb-4 text-center" role="contentinfo" tabIndex="0">
                        <img
                            src={`${globals["app-url-bucket"]}${contenuto?.secondaImmagine?.file}`}
                            title={contenuto?.titoloContenuto?.titoloContenuto}
                            alt={contenuto?.secondaImmagine?.testoAlternativo}
                            className="ViewCategoryComponent__imgTwo img-fluid"
                        />
                    </div>
                ) : null}

                <CategoryDetailViewTextComponent info={contenuto?.contenuto?.testoContenuto}></CategoryDetailViewTextComponent>
                <CategoryDetailNotaMetodologicaComponent info={contenuto?.notaMetodologica?.testoNota}></CategoryDetailNotaMetodologicaComponent>
                {
                    contenuto?.immagini?.map(img => {
                        const { didascalia, immagine, allegato, testoAlternativo} = img;
                        return (
                            <CategoryDetailViewImageComponent
                                key={didascalia}
                                title={didascalia}
                                src={immagine}
                                alt={testoAlternativo}
                                allegato={allegato}
                            >
                            </CategoryDetailViewImageComponent>
                        );
                    })
                }
                <CategoryDetailAllegattiListComponent items={contenuto?.allegati}></CategoryDetailAllegattiListComponent>
                <CategoryDetailAppListComponent items={contenuto?.approfondimenti}></CategoryDetailAppListComponent>
                {contenuto?.contenuto?.testoContenuto || contenuto?.notaMetodologica?.testoNota ?
                    <CategoryDetailMoreInformationComponent info={contenuto?.maggioriInformazioni}></CategoryDetailMoreInformationComponent>
                    : <></>
                }
                <SeparatorBlue600 className="mb-3"></SeparatorBlue600>
                <CategoryDetailListLink voci={category?.sottoVoci || []} isSection={false}></CategoryDetailListLink>
            </div>

        </>
    );
};

ViewCategoryComponent.defaultProps = {
    info: "",
};

export default ViewCategoryComponent;